import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLoad, PageHead, Card, BarChart, Pager, Skeleton, Empty, ErrorBox, Avatar, num, fdt, exportCsv, Btn } from "../ui";

const TAKE = 50;
const short = (d) => {
  const [, m, day] = d.split("-");
  return `${Number(day)}/${Number(m)}`;
};

export default function WatchEarn() {
  const [skip, setSkip] = useState(0);
  const { data, loading, error, reload } = useLoad("watchClaims", { take: TAKE, skip }, [skip]);
  const items = (data && data.items) || [];
  const today = data ? data.days[data.days.length - 1].count : 0;

  return (
    <div>
      <PageHead icon="fa-regular fa-circle-play" title="Watch & Earn" subtitle="वेबसाइट से video देखकर Karma कमाने वाले claims (Karma और wallet App panel में हैं)"
        actions={<Btn icon="fa-solid fa-download" disabled={!items.length} onClick={() => exportCsv(items.map((i) => ({ user: i.name, link: i.linkId, day: i.day, at: i.at })), "ycnp-watch-claims")}>CSV</Btn>} />
      <ErrorBox msg={error} retry={reload} />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 mb-5">
        <Card title="पिछले 14 दिन" icon="fa-solid fa-chart-column" className="xl:col-span-2">
          {loading && !data ? <Skeleton rows={4} /> : data && <BarChart height={180} color="#10b981" label="Daily watch claims" data={data.days.map((d) => ({ label: d.day, short: short(d.day), value: d.count }))} />}
        </Card>
        <Card title="Summary" icon="fa-solid fa-list-check">
          <p className="text-[13px] wa-muted">आज के claims</p>
          <p className="text-3xl font-extrabold tabular-nums">{num(today)}</p>
          <p className="text-[13px] wa-muted mt-4">अब तक कुल</p>
          <p className="text-3xl font-extrabold tabular-nums">{num(data && data.total)}</p>
          <p className="text-[12px] wa-muted mt-4">हर user एक video पर दिन में एक ही बार Karma पाता है।</p>
        </Card>
      </div>
      <Card pad={false} title="हाल के claims">
        {loading && !data ? <div className="p-4"><Skeleton rows={6} /></div> : !items.length ? <Empty icon="fa-regular fa-circle-play" title="अभी कोई claim नहीं" /> : (
          <div className="overflow-x-auto">
            <table className="wa-tbl">
              <thead><tr><th>User</th><th>Video link ID</th><th>दिन</th><th>समय</th></tr></thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id}>
                    <td><Link to={`/website/users?open=${i.userId}`} className="flex items-center gap-2.5 font-semibold hover:underline"><Avatar name={i.name} size={28} />{i.name}</Link></td>
                    <td className="font-mono text-[12.5px]">{i.linkId}</td>
                    <td className="text-[12.5px]">{i.day}</td>
                    <td className="text-[12.5px] wa-muted">{fdt(i.at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <Pager total={data && data.total} take={TAKE} skip={skip} onChange={setSkip} />
      </Card>
    </div>
  );
}
